import React, { memo } from 'react'

import { Skeleton } from '@material-ui/lab'

const TileInfo = ({ classNameContainer = '', title = '', content = '' }) => {
  return (
    <div className={`tile_info_container ${classNameContainer}`}>
      <span className="tile_info_title">{title}</span>
      {content ? (
        <span className="tile_info_content">{content}</span>
      ) : (
        <Skeleton variant="text" width={'100%'} />
      )}
    </div>
  )
}

export default memo(TileInfo)
